export default __webpack_public_path__ + "static/media/forbidden-reports.3152f464.svg";